var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadSuraB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.c_acua{fill:#00AEC7;}\n\t.stroker{\nfill:none;\n\t  \tstroke: #E3E829;\n  \t\tstroke-width:2;\n\t\tstroke-linecap:round;\n\t\tstroke-linejoin:round;\n\n\t     \n\t    stroke-dasharray: 200;\n\n\t    animation: animate 4s linear alternate infinite;\n\t\t}\n\n\t@keyframes animate {\n\t   \t\n\t   \t0%{\n\t   \t\tstroke-dasharray: 200;\n\t    }\n\t    \n\n\t    100%{\n\t   \t\tstroke-dasharray: 20.5;\n\t    }\n\t    \n\n\t}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    transform: "translate(0 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_SURA-blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "c_acua",
    d: "M30.5,39.4c0-0.1,0-0.1,0-0.1c-1.6,0.7-5.2,1.3-7.5,1.7c-1.9,0.3-3.6,0.3-4.5,0.4l-0.4,0 c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0,0.1c0.5,0.5,1.1,0.8,1.8,0.9c1.3,0.2,3.1-0.2,5.4-0.8C27.1,41,28.8,40.3,30.5,39.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    className: "c_acua",
    d: "M30.7,40.4c-1.3,0.8-2.7,1.5-4.1,2c-1.8,0.6-3.7,1.1-5.6,1.4c0,0-0.1,0-0.1,0.1 c0,0,0,0.1,0,0.1c0.4,0.3,0.8,0.4,1.3,0.5c0.8,0.1,1.6,0,2.3-0.3c0.8-0.3,1.6-0.6,2.4-1c0.8-0.4,1.6-0.8,2.3-1.3 C29.8,41.4,30.3,41,30.7,40.4C30.7,40.4,30.7,40.4,30.7,40.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    className: "c_acua",
    d: "M22.2,21.8c0.4,0.5,1,0.8,1.6,1l0,0c0.2,0,11.1,3,14,3.8c1.3,0.3,2.3,0.6,2.7,0.8 c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1c-1.8-0.7-13.1-5.1-17.4-6.8l-1.8-0.7c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0.1c0,0.5,0.2,1.1,0.5,1.5 C22,21.5,22.1,21.6,22.2,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    className: "c_acua",
    d: "M22.7,17.4c0.2,0.3,0.5,0.5,0.8,0.7c0.1,0.1,0.3,0.2,0.4,0.2l1,0.5c0.6,0.3,9,4.3,10.3,4.9 c1.5,0.7,2.9,1.4,3.6,1.7c0.1,0,0.1,0,0.1-0.1c-1.6-1-7.6-4.8-12-7.5L23.8,16l-0.6-0.4L22.2,15c-0.1,0-0.1,0-0.1,0 c0,0,0,0,0,0.1c0,0.5,0,1.1,0.2,1.6C22.4,16.9,22.5,17.2,22.7,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    className: "c_acua",
    d: "M30.3,42.3C30.3,42.3,30.3,42.3,30.3,42.3c-1.2,1.1-2.7,1.9-4.2,2.4c0,0-0.1,0-0.1,0.1 c0,0,0,0.1,0.1,0.1c0.1,0.1,0.9,0.5,2.5-0.3C29.5,44.1,30.1,43.3,30.3,42.3C30.4,42.3,30.4,42.3,30.3,42.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    className: "c_acua",
    d: "M40.4,30.6c-0.7,0.2-3.4,0.9-5.8,1.5c-2.1,0.5-4.4,1.2-4.4,1.2c-0.2,0.1-0.2,0.2-0.1,0.2 c0.1,0.1,0.2,0.3,0.3,0.6c0.2,0.5,0.8,0.6,1.3,0.4c0,0,0,0,0,0c0.1,0,8.3-3.5,8.6-3.7C40.5,30.6,40.5,30.6,40.4,30.6 C40.5,30.6,40.4,30.6,40.4,30.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    className: "c_acua",
    d: "M36.8,36.3L36.8,36.3c-1.1,0.9-2.8,2.4-4.5,3.8c-0.2,0.2-0.3,0.4-0.3,0.7 c-0.1,0.4-0.2,0.8-0.4,1.1c0,0.1,0,0.2,0.2,0.1C33.1,40.6,36.1,37.3,36.8,36.3C36.9,36.3,36.8,36.3,36.8,36.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    className: "c_acua",
    d: "M42,28.4c-1.5-0.3-19.1-3.4-19.1-3.4c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1 c0.3,1.1,1.1,1.9,2.2,2.2c0.1,0,0.3,0.1,0.4,0.1c0,0,15,1,16.7,1.1C42,28.5,42,28.4,42,28.4C42,28.4,42,28.4,42,28.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    className: "c_acua",
    d: "M41.3,29.4c-0.5,0-1.6,0-3,0c-1.6,0-3.5,0-5.3,0c-2.4,0-6.2,0-6.2,0c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1c0.1,0.3,0.3,0.6,0.5,0.8c0.4,0.5,0.9,0.7,1.5,0.8c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0 c0.1,0,11.5-1.6,12.1-1.7C41.3,29.5,41.3,29.5,41.3,29.4C41.3,29.4,41.3,29.4,41.3,29.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    className: "c_acua",
    d: "M39.5,32.2c-0.8,0.5-2.8,1.7-4.6,2.8c-1,0.6-2.2,1.3-2.9,1.7c-0.1,0-0.1,0-0.1,0.2 c0,0,0,0.2,0,0.4c0.1,1,0.5,0.9,1,0.4l0.1-0.1c2-1.6,5.6-4.7,6.4-5.4C39.5,32.2,39.5,32.2,39.5,32.2"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroker",
    d: "M55,30c0,13.8-11.2,25-25,25S5,43.8,5,30S16.2,5,30,5c8.5,0,16,4.2,20.5,10.7c2.7,3.9,4.4,8.7,4.5,13.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadSuraB);
export default __webpack_public_path__ + "static/media/LoadSURA_b.a421ef8ee004a562262781caf2160ea4.svg";
export { ForwardRef as ReactComponent };